import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../core/guards/auth.guard';
import { ContactsResolverService } from '../../resolvers/contacts-resolver.service'
import { MakesListComponent } from './makes-list/makes-list.component';
import { MakesResolverService } from './makes-resolver.service';
import { ChooseDocumentsComponent } from './choose-documents/choose-documents.component';
import { DocumentsResolverService } from './documents-resolver.service';
import { MyDocumentsResolverService } from './my-documents-resolver.service';
import { SendMessageComponent } from './send-message/send-message.component';


const routes: Routes = [
    {
        path: 'stworz-wysylke',
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                redirectTo: 'marki',
                pathMatch: 'full'
            },
            {
                path: 'marki',
                component: MakesListComponent,
                resolve: {
                    makes: MakesResolverService
                }
            },
            {
                path: 'wybierz-dokumenty',
                component: ChooseDocumentsComponent,
                resolve: {
                    documents: DocumentsResolverService,
                    myDocuments: MyDocumentsResolverService
                }
            },
            {
                path: 'wyslij',
                component: SendMessageComponent,
                resolve: {
                    contacts: ContactsResolverService,
                    documents: DocumentsResolverService,
                    myDocuments: MyDocumentsResolverService
                }
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CreateMessageRoutingModule { }
